import { VatType } from '../config/i18nConfig'
import { useEffect, useMemo, useState } from 'react'
import useVatTypes from './useVatTypes'
import { useTranslation } from 'react-i18next'
import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'

type ReturnProps = {
    vatType: VatType
    vatTypeName: string
    setId: (id: string) => void
}

export default function useVatType(id?: string): ReturnProps {
    const { i18n } = useTranslation()

    const [_id, setId] = useState<string>(id)
    const { loaded, vatTypes } = useVatTypes()

    const _vatType = useMemo(() => loaded && (vatTypes || []).find(vatType => vatType.id === _id), [_id, loaded, vatTypes])
    const vatTypeName = useMemo<string>(() => {
        return getI18NName(_vatType, i18n.language)
    }, [_vatType, i18n.language])

    useEffect(() => {
        setId(id)
    }, [id])

    return { vatType: _vatType, vatTypeName, setId }
}
